<ng-container *transloco="let t; read: 'admin-hours-dashboard'">
  <ng-template #dashboardConfigTemplate>
    <form *ngIf="!loading" class="full-width" [formGroup]="form">
      <div class="form-row">
        <div class="col">
          <mat-form-field>
            <mat-label>{{ t('window') }}</mat-label>
            <mat-select formControlName="window">
              <mat-option *ngFor="let w of possibleWindows" [value]="w">{{ w }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="window?.value !== 'custom'" class="col">
          {{ t('showingPlotsFor') }}:
          <br />
          {{ t('start') }}: {{ windowObj?.windowStart | momentPipe }} <br />
          {{ t('end') }}: {{ windowObj?.windowEnd | momentPipe }}
        </div>
      </div>
      <div class="form-row full-width">
        <div *ngIf="window?.value === 'custom'" class="col full-width">
          <label class="admin-hours-dashboard__datetime-field">
            <span class="admin-hours-dashboard__datetime-label"> {{ t('start') }} ({{ orgData?.getTimezone() }}) </span>
            <input formControlName="customStart" pInputText type="datetime-local" [placeholder]="t('start')" />
            <app-form-field-help [control]="customStart">
              <ng-container form-field-help-errors>
                <div *ngIf="customStart?.invalid">{{ t('invalidStartTime') }}</div>
              </ng-container>
            </app-form-field-help>
          </label>
        </div>
        <div *ngIf="window?.value === 'custom'" class="col full-width">
          <label class="admin-hours-dashboard__datetime-field">
            <span class="admin-hours-dashboard__datetime-label"> {{ t('end') }} ({{ orgData?.getTimezone() }}) </span>
            <input formControlName="customEnd" pInputText type="datetime-local" [placeholder]="t('end')" />
            <app-form-field-help [control]="customEnd">
              <ng-container form-field-help-errors>
                <div *ngIf="customEnd?.invalid">{{ t('invalidEndTime') }}</div>
              </ng-container>
            </app-form-field-help>
          </label>
        </div>
      </div>
      <button *ngIf="window?.value === 'custom'" color="primary" mat-raised-button (click)="emitChanges()">
        {{ t('apply') }}
      </button>
    </form>
  </ng-template>

  <ng-template #dashboardTemplate>
    <div class="row">
      <div class="col">
        <app-event-hours-table
          *ngIf="!loading"
          [allDataUserMap]="allDataUserMap"
          [entityStatsMap]="entityStatsMap"
          [eventTypes]="eventTypes"
          [orgData]="orgData"
          [windowObj]="windowObj"
        >
        </app-event-hours-table>
      </div>
    </div>
  </ng-template>

  <div *ngIf="loadingInProgress$ | async" class="d-flex justify-content-center">
    <app-progress-spinner></app-progress-spinner>
  </div>
  <div [hidden]="loadingInProgress$ | async">
    <app-analytics-dashboard
      [dashboardConfigTemplate]="dashboardConfigTemplate"
      [dashboardTemplate]="dashboardTemplate"
      [lastRefreshTime]="lastRefreshTime"
    >
    </app-analytics-dashboard>
  </div>
</ng-container>
